<template>
  <BaseVeeForm :action="addSubscriptionOrder" @success="$emit('success')">
    <template #default="formProps">
      <BaseButton primary :outline="nested" :small="nested" :disabled="formProps.isPending">
        Add Order
      </BaseButton>
      <ValidationProvider name="period" slim vid="period">
        <template #default="{ errors }">
          <BaseFormGroup>
            <BaseFormInput type="hidden" :value="period" />
            <BaseFormInlineMessage v-if="errors.length" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
    </template>
  </BaseVeeForm>
</template>

<script>
import { accountSubscriptionSubscriptionOrdersClient } from '@/api/clients';

export default {
  props: {
    period: {
      type: Number,
      default: -1,
    },
    accountSubscriptionId: {
      type: String,
      required: true,
    },
    nested: Boolean,
  },
  methods: {
    addSubscriptionOrder() {
      return accountSubscriptionSubscriptionOrdersClient.store(this.accountSubscriptionId, {
        ...(this.period === -1 ? {} : { period: this.period }),
      });
    },
  },
};
</script>
